export default {
  'batchDeduct.batchCode.title': 'Redemption Code',
  'batchDeduct.batchCode.warning': 'For personal use only. Photos or screenshots are invalid.',
  'batchDeduct.batchCode.code': 'Redemption Content',
  'batchDeduct.batchCode.counts': 'pieces',
  'batchDeduct.batchCode.copySuccess': 'Redemption code copied successfully',
  'batchDeduct.batchCode.success': 'Redemption successful',
  'batchDeduct.batchCode.produce_fail': 'Failed to generate redemption code',
  'batchDeduct.title': 'Batch Redemption',
  'batchDeduct.error.stamp_no_permission': 'The stamp does not have redemption permission for the following vouchers',
  'batchDeduct.cancel_all': 'Cancel All',
  'batchDeduct.partial_deduct': 'Partial Redemption',
  'batchDeduct.message.following_ticket_deduct_success': 'The following vouchers were successfully redeemed',
} as Record<string, string>;
